import React, { Component, useState } from "react";
import { Eye, ChevronRight, ChevronLeft, Share } from "react-feather";
import playbutton from "../img/videoslider/play-button.svg";
import image1 from "../img/whatsnews/img1.png";
import image2 from "../img/whatsnews/img2.png";
import image3 from "../img/whatsnews/img3.png";
import image4 from "../img/whatsnews/img4.png";
import image5 from "../img/whatsnews/img5.png";
import image6 from "../img/whatsnews/img6.png";
import popuplogo from "../img/knowusmore/popup-logo.svg";

import { connect } from "react-redux";
class WhatsNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      thumbsSwiper: null,
    };
  }

  render() {
    return (
      <>
        <div>
          <div className="flex justify-between items-center lg:mt-16 md:mt-16 mt-12 mb-8">
            <h2 className="fsize28 font-bold sm-fsize16">WHAT'S NEW</h2>
            <div className="flex ">
              <ChevronLeft
                width="30px"
                height="30px"
                className="trend-left-i mr-2"
              />
              <ChevronRight
                width="30px"
                height="30px"
                className="trend-right-i"
              />
            </div>
          </div>

          <div className="column-count3 sm-column-count2 lg:gap-10 md:gap-10 gap-4">
            {/* {this.props.TEAMICICIPOST
                ? this.props.TEAMICICIPOST.data.map((data, index) => {
                    return ( */}
            <div>
              <div className="lg:mb-12 md:mb-12">
                <div className="img__whatnews  lg:mb-0 md:mb-0 mb-4">
                  <div className="relative">
                    <img src={image1} className="w-full maxh-233px  " />
                    <div className="playbutton-place w-full">
                      <img src={playbutton} className="playbutton-w" />
                    </div>
                  </div>

                  <div className="flex img__whatnews_layer justify-center items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>

                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        <p className="whats-date fsize18  flex items-center">
                          <Eye width="20px" height="20px" className="mr-2" />
                          <span>1.5k views</span>
                        </p>
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="img__whatnews  lg:mb-0 md:mb-0 mb-4">
                  <img src={image4} className="w-full maxh-522px " />
                  <div className="flex img__whatnews_layer justify-center items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>

                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        {/* <p className="whats-date fsize18  flex items-center">
                      <Eye width="20px" height="20px" className="mr-2" />
                      <span>1.5k views</span>
                    </p> */}
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:mb-12 md:mb-12">
                <div className="img__whatnews">
                  <img src={image2} className="w-full maxh-382px " />
                  <div className="flex  img__whatnews_layer justify-center items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>

                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        {/* <p className="whats-date fsize18  flex items-center">
                      <Eye width="20px" height="20px" className="mr-2" />
                      <span>1.5k views</span>
                    </p> */}
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="img__whatnews  lg:mb-0 md:mb-0 mb-4">
                  <img src={image5} className="w-full  maxh-373px" />
                  <div className="img__whatnews_layer flex justify-center items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>
                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        {/* <p className="whats-date fsize18  flex items-center">
                      <Eye width="20px" height="20px" className="mr-2" />
                      <span>1.5k views</span>
                    </p> */}
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="img__whatnews  lg:mb-0 md:mb-0 mb-4">
                  <img src={image3} className="w-full maxh-521px " />
                  <div className="flex justify-center img__whatnews_layer items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>

                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        {/* <p className="whats-date fsize18  flex items-center">
                      <Eye width="20px" height="20px" className="mr-2" />
                      <span>1.5k views</span>
                    </p> */}
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:mt-12 md:mt-12">
                <div className="img__whatnews  lg:mb-0 md:mb-0 mb-4">
                  <div className="relative">
                    <img src={image6} className="w-full  maxh-233px " />
                    <div className="playbutton-place w-full">
                      <img src={playbutton} className="playbutton-w" />
                    </div>
                  </div>
                  <div className="flex  img__whatnews_layer justify-center items-center">
                    <div className=" text-center w-80per">
                      <div className="flex justify-center">
                        <img src={popuplogo} className="w-20px" />
                        <p className="text-white font-semibold ml-2  fsize20">
                          ICICI Bank iTreasury
                        </p>
                      </div>

                      <div className="flex justify-evenly mt-4">
                        <p className="whats-date fsize18">5 days ago</p>
                        <p className="whats-date fsize18  flex items-center">
                          <Eye width="20px" height="20px" className="mr-2" />
                          <span>1.5k views</span>
                        </p>
                      </div>

                      <p className="share-to fsize18 justify-center mt-20 flex items-center">
                        <span>Share</span>
                        <Share width="20px" height="20px" className="ml-2" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* )}):""} */}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    TEAMICICIPOST: state.Home.home.TEAMICICIPOST,
  };
};

export default connect(mapStateToProps)(WhatsNew);
